import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import Post from "../assets/images/Laundry/Laundry.png";
import { Dropdown } from "primereact/dropdown";
import useDropdownMenu from "react-accessible-dropdown-menu-hook";
import axios from "../axios";
import { useCartStore } from "../store/useStore";
import { object } from "yup";
import { useTranslation } from "react-i18next";
import LaundryCarosle from "./LaundryCarosle";
import ReactGA from "react-ga4";
import { ThemeContext } from "../context/ThemeContext";
import Sar from "../assets/images/icons/Sar";
import useMixpanel from "../hooks/useMixpanel";
import { trackCategoryViewed } from "../utils/mixpanel";
import { set } from "lodash";

function ViewLaundryCartModal({
  laundryId,
  show,
  handleClose,
  laundry_uuid,
  itemChange,
  is_express,
  service_fee,
  vat,
  discount_percentage,
  min_amount,
  data,
  images,
  use_banners_in_popup,
}) {
  const [selectedItem, setSelectedItem] = useState(null);
  const [isExternalLaundry, setIsExternalLaundry] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [count, setCount] = useState(1);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const [laundaryItems, setLaundaryItems] = useState([]);
  const [laundaryCategories, setLaundaryCategories] = useState([]);
  const [laundaryServices, setLaundaryServices] = useState([]);
  const [currentService, setCurrentService] = useState();
  const [price, setPrice] = useState();
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [itemsLoading, setItemsLoading] = useState(false);

  const { theme } = useContext(ThemeContext);
  const { track } = useMixpanel();

  console.log("theme", theme);
  const { laundryCart, setLaundryCart } = useCartStore((state) => ({
    laundryCart: state.laundryCart,
    setLaundryCart: state.setLaundryCart,
  }));

  useEffect(() => {
    if (itemChange) {
      const itemCategoryId =
        itemChange?.category?.id ?? itemChange?.category_id;
      const itemCategoryName =
        itemChange?.category?.name ?? itemChange?.category;
      setSelectedCategory(
        laundaryCategories.find(
          (cat) =>
            (itemCategoryId != null && cat.id == itemCategoryId) ||
            cat.name === itemCategoryName,
        ) || itemChange?.category,
      );
      setSelectedItem(itemChange);
      setSelectedService(itemChange.services_name);
      setLaundaryServices(itemChange?.services);
      setPrice(itemChange?.price);
      setCount(itemChange.quantity);
      setCurrentService(itemChange?.services_item);
    } else {
      setSelectedCategory(null);
      setSelectedItem(null);
      setSelectedService(null);
      setLaundaryServices(null);
      setCurrentService(null);
      setPrice(null);
      setCount(1);
    }
  }, [itemChange, laundaryCategories]);

  console.log(laundaryServices, "services");

  const navigate = useNavigate();
  const handleIncrease = () => {
    setCount((prev) => {
      if (prev <= 1) {
        return 1;
      }
      return prev - 1;
    });
    ReactGA.event({
      category: "Decrease count in laundry page ",
      action: "Click",
      value: `count: ${count} `,
    });
  };
  const handleDecrease = () => {
    setCount((prev) => prev + 1);
    ReactGA.event({
      category: "Increase count in laundry page ",
      action: "Click",
      value: `count: ${count} `,
    });
  };

  const SetCartItem = (item) => {
    const tempCart = [...JSON.parse(JSON.stringify(laundryCart)), item];
    setLaundryCart(tempCart);
  };

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setSelectedService(null);
    setCurrentService(null);
  };

  const lang = localStorage.getItem("lang");
  useEffect(() => {
    const getData = async () => {
      setCategoriesLoading(true);
      axios
        .get(`/${room_uuid}/laundry/${laundry_uuid}`, {
          headers: {
            lang: lang,
          },
        })
        .then(async (res) => {
          const data = res.data.data.laundry;
          setLaundaryItems(data.items);
          setLaundaryCategories(data.categories);
          // console.log(data, "data");
          setIsExternalLaundry(data.is_external === 1 ? true : false);
        })
        .finally(() => {
          setCategoriesLoading(false);
        });
    };
    getData();
  }, [lang]);

  useEffect(() => {
    let ignore = false;
    const getCategories = async () => {
      if (laundaryCategories.length > 0) {
        const tempCategory = laundaryCategories.find(
          (cat) => cat.name === selectedCategory?.name,
        );
        if (!tempCategory) {
          return;
        }
        setItemsLoading(true);
        axios
          .get(
            `/${room_uuid}/laundry/categure_items/${tempCategory.id}?laundry_id=${laundryId}`,
            {
              headers: {
                lang: lang,
              },
            },
          )
          .then((res) => {
            if (ignore) return;
            const data = res.data.data;
            setLaundaryItems(data);
          })
          .finally(() => {
            if (ignore) return;
            setItemsLoading(false);
          });
      }
    };
    getCategories();
    return () => {
      ignore = true;
    };
  }, [selectedCategory, lang]);

  const removeItem = async (item) => {
    const tempItems = await laundryCart.filter((a) => item.id !== a.id);
    await setLaundryCart(tempItems);
  };

  useEffect(() => {
    setLaundaryServices(selectedItem?.services);
  }, [selectedItem, lang]);

  const handleSubmit = async () => {
    ReactGA.event({
      category: "Submit after click on button 'Add'  in laundry page ",
      action: "Click",
      value: ` `,
    });
    if (selectedItem && selectedService) {
      if (rawPath.split("/")[2] !== "LaundryOrderPayment") {
        navigate(
          theme
            ? `/${room_uuid}/hotel-services/laundry/order/${laundry_uuid}/${laundryId}/v/${vat}/fee/${service_fee}/min/${min_amount}`
            : `/${room_uuid}/LaundryOrderPayment/${laundry_uuid}/${laundryId}/v/${vat}/fee/${service_fee}/min/${min_amount}`,
        );
      }
      SetCartItem({
        ...selectedItem,
        quantity: count,
        category: selectedCategory,
        category_id: selectedCategory?.id,
        services_name: selectedService,
        service_id: currentService.id,
        item_id: selectedItem.id,
        price: currentService?.price,
        price_express:
          (Number(currentService?.price) *
            Number(currentService?.express_percentage)) /
            100 +
          Number(currentService?.price),
        services_item: selectedItem?.services.filter(
          (a) => a.id == currentService.id,
        )[0],
      });
      setSelectedItem(null);
      setCurrentService(null);
      handleClose();
    }
  };

  const handelEdit = async () => {
    if (!selectedItem || !selectedService || !currentService) {
      return;
    }
    const update = laundryCart.map((a) => {
      if (a.id != itemChange.id) {
        return a;
      }
      return {
        ...a,
        name: selectedItem.name,
        id: selectedItem.id,
        image: selectedItem.image,
        services: selectedItem.services,
        quantity: count,
        category: selectedCategory,
        category_id: selectedCategory?.id,
        services_name: selectedService,
        service_id: currentService.id,
        item_id: selectedItem.id,
        price: currentService?.price,
        price_express:
          (Number(currentService?.price) *
            Number(currentService?.express_percentage)) /
            100 +
          Number(currentService?.price),
        services_item: selectedItem?.services.filter(
          (s) => s.id == currentService.id,
        )[0],
      };
    });
    setLaundryCart(update);
    handleClose();
  };

  const currency = localStorage.getItem("currency");

  // Custom item template for dropdown to show image and name
  const itemTemplate = (option) => {
    if (!option) return null;
    return (
      <div className="flex align-items-center">
        <img
          src={option.image}
          alt={option.name}
          style={{
            width: "32px",
            height: "32px",
            marginRight: "8px",
            objectFit: "cover",
            backgroundColor: "white",
          }}
        />
        <span>{option.name}</span>
      </div>
    );
  };

  const selectedItemTemplate = (option) => {
    if (itemsLoading) return <span>{t(`Loading...`)}</span>;
    if (!option) return <span>{t(`Select Item`)}</span>;
    return (
      <div className="flex align-items-center">
        <img
          src={option.image}
          alt={option.name}
          style={{
            width: "24px",
            height: "24px",
            marginRight: "8px",
            objectFit: "cover",
            backgroundColor: "white",
          }}
        />
        <span>{option.name}</span>
      </div>
    );
  };

  console.log("laundaryItems", laundaryItems);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        className={`${
          theme ? "food-modal" : ""
        } laundary-modal custom-width b-r ${lang == "ar" ? "ar_lang" : ""}`}
      >
        <Modal.Body>
          <Button className="close-btn" onClick={handleClose}>
            <div className="close-btn-wrap"></div>
            <div className="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height=".45em"
                viewBox="0 0 384 512"
              >
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
              </svg>
            </div>
          </Button>
          <div className="laundray-img-container">
            {use_banners_in_popup ? (
              <LaundryCarosle headerImages={images} />
            ) : (
              <LaundryCarosle headerImages={images} />
            )}
          </div>
          <div className="clear"></div>
          <div className="full-div padd-div add-item">
            <i className="fa fa-plus-square" style={{ color: "#00638E" }}></i>
            <p>{t("Add Item")}</p>
          </div>
          <div className="full-div padd-div">
            <div className="flex justify-content-center drop-container">
              <Dropdown
                value={selectedCategory}
                onChange={(e) => {
                  console.log(e.value, "test");
                  setSelectedCategory(e.value);

                  ReactGA.event({
                    category: "Select Category in laundry page",
                    action: "Click",
                    value: `category_name: ${e.value.name}`,
                  });

                  // Track Category Viewed using new Mixpanel service
                  trackCategoryViewed({
                    category_id: e.value.id,
                    category_name: e.value.name,
                    category_type: "laundry",
                    is_external: isExternalLaundry,
                  });

                  setSelectedItem(null);
                  setSelectedService(null);
                  setCurrentService(null);
                }}
                panelClassName={`panel-drop tar ${theme ? "dark_theme" : ""}`}
                options={laundaryCategories || []}
                optionLabel="name"
                placeholder={
                  categoriesLoading ? t(`Loading...`) : t(`Select a Category`)
                }
                className="w-full md:w-14rem tar"
                disabled={categoriesLoading}
                dropdownIcon={
                  categoriesLoading
                    ? "pi pi-spinner pi-spin"
                    : "pi pi-chevron-down"
                }
                emptyMessage={
                  categoriesLoading ? t(`Loading...`) : t("No items found")
                }
              />
            </div>
            <div className="flex justify-content-center drop-container mt-3">
              <Dropdown
                value={selectedItem}
                onChange={(e) => {
                  handleSelectItem(e.value);
                  ReactGA.event({
                    category: "Select item in laundry page ",
                    action: "Click",
                    value: `item name: ${e.value.name} `,
                  });

                  // Track Menu Item Viewed using new Mixpanel service
                  track.menuItemViewed({
                    item_id: e.value?.id || "",
                    item_name:
                      laundaryItems?.find((item) => item.id === e.value.id)
                        ?.name || "",
                    category_name: selectedCategory?.name || "",
                    price: e.value?.price || 0,
                    currency: currency || "AED",
                    is_combo: false,
                  });
                }}
                panelClassName={`panel-drop ${theme ? "dark_theme" : ""}`}
                options={laundaryItems && selectedCategory ? laundaryItems : []}
                optionLabel="name"
                placeholder={t(`Select Item`)}
                className="w-full md:w-14rem"
                itemTemplate={itemTemplate}
                valueTemplate={selectedItemTemplate}
                disabled={!selectedCategory || itemsLoading}
                dropdownIcon={
                  itemsLoading ? "pi pi-spinner pi-spin" : "pi pi-chevron-down"
                }
                emptyMessage={
                  itemsLoading ? t(`Loading...`) : t("No items found")
                }
              />
            </div>
            <div className="flex justify-content-center drop-container mt-3">
              <Dropdown
                value={selectedService ? selectedService : null}
                onChange={(e) => {
                  setSelectedService(e.value);
                  ReactGA.event({
                    category: "Select service in laundry page ",
                    action: "Click",
                    value: `service name: ${e.value} `,
                  });

                  const tempService = selectedItem?.services.filter(
                    (a) => a.name === e.value,
                  )[0];
                  setCurrentService(tempService);
                }}
                panelClassName={`panel-drop  ${theme ? "dark_theme" : ""}`}
                options={laundaryServices ? laundaryServices : []}
                optionLabel="name"
                optionValue="name"
                placeholder={
                  itemsLoading ? t(`Loading...`) : t(`Select Serivce`)
                }
                className="w-full md:w-14rem"
                disabled={!selectedItem || itemsLoading}
                dropdownIcon={
                  itemsLoading ? "pi pi-spinner pi-spin" : "pi pi-chevron-down"
                }
              />
            </div>

            <div className="d-flex justify-content-between py-3 align-items-center flex-wrap  mt-2">
              <Form.Group
                className="mb-3 d-flex align-items-center"
                controlId="formBasicEmail"
              >
                <Form.Label className="count">{t(`Count`)}</Form.Label>
                <div className="count-order-amount mx-2">
                  <Button className="small" onClick={handleIncrease}>
                    <i className="fa fa-minus"></i>
                  </Button>
                  <p>{count}</p>
                  <Button className=" small" onClick={handleDecrease}>
                    <i className="fa fa-plus"></i>
                  </Button>
                </div>
              </Form.Group>
              <div className="d-flex">
                <Form.Label className="mr-2 f-16">{t(`Price`)}</Form.Label>
                {discount_percentage && (
                  <p className="f-16 discount_percentage">
                    {is_express ? (
                      currentService ? (
                        <>
                          {currency === "SAR" ? (
                            <Sar color="currentcolor" />
                          ) : (
                            `${currency} `
                          )}{" "}
                          {(Number(currentService?.price) *
                            Number(currentService?.express_percentage)) /
                            100 +
                            Number(currentService?.price) * count -
                            (Number(currentService?.price) *
                              Number(currentService?.express_percentage)) /
                              100 +
                            Number(currentService?.price) *
                              count *
                              Number(discount_percentage / 100)}
                        </>
                      ) : price ? (
                        `${currency} ${
                          Number(price) * count -
                          Number(price) *
                            count *
                            Number(discount_percentage / 100)
                        }`
                      ) : (
                        ""
                      )
                    ) : currentService ? (
                      <>
                        {currency === "SAR" ? (
                          <Sar color="currentcolor" />
                        ) : (
                          `${currency} `
                        )}{" "}
                        {currentService.price * count -
                          currentService.price *
                            count *
                            Number(discount_percentage / 100)}
                      </>
                    ) : price ? (
                      ` ${currency} ${
                        Number(price) * count -
                        Number(price) *
                          count *
                          Number(discount_percentage / 100)
                      }`
                    ) : (
                      ""
                    )}
                  </p>
                )}
                <p
                  className={`f-16 ${
                    discount_percentage
                      ? "laundry_price"
                      : "discount_percentage"
                  }`}
                >
                  {is_express ? (
                    currentService ? (
                      `${currency} ${
                        Number(currentService.price) *
                        (1 + Number(currentService.express_percentage) / 100) *
                        count
                      }`
                    ) : price ? (
                      `${currency} ${Number(price) * count}`
                    ) : (
                      ""
                    )
                  ) : currentService ? (
                    <>
                      {currency === "SAR" ? (
                        <Sar color="currentcolor" />
                      ) : (
                        `${currency} `
                      )}
                      {currentService.price * count}
                    </>
                  ) : price ? (
                    `${currency} ${Number(price) * count}`
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </div>
            <Row className="mt-4">
              <Col lg="6" md="6" xs="6" className="p-0  pl-2">
                {itemChange ? (
                  <Button
                    className="reg-btn big laundary-btn"
                    onClick={handelEdit}
                  >
                    {t(`Edit`)}
                  </Button>
                ) : (
                  <Button
                    className="reg-btn big laundary-btn"
                    onClick={handleSubmit}
                  >
                    {t(`Add`)}
                  </Button>
                )}
              </Col>
              <Col lg="6" md="6" xs="6" className="p-0 px-2">
                <Button
                  className="reg-btn big laundary-btn cancel"
                  onClick={handleClose}
                >
                  {t(`Cancel`)}
                </Button>
              </Col>
            </Row>
          </div>
          <div className="spacer-10"></div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ViewLaundryCartModal;
